
import { format } from "date-fns"
import FormError from "../../riutilizabili/FormError"
import InputForm from "../../riutilizabili/forms/InputForm"


export default function CreaInventario({
    onCloseInv ,
    setInputsCrea ,
    inputsCrea ,
    error
}) {
    
    return (
        <div className="ms-0 ps-0 col-6 ">
            <div className="d-flex col-12  ps-0 ms-0">
                <InputForm
                    label='Quantità rilevata'
                    name={'qtAttualeRilevata'}
                    value={inputsCrea?.qtAttualeRilevata || ''}
                    onChange={(name , value) => setInputsCrea(values => ({ ...values, [name]: value }))}
                    verNumber
                    classi={' col-4 ms-4 ps-1 '}
                    errors={error}
                />
                <InputForm
                    label='Data rilevamento'
                    name={'dataOraOperazione'}
                    type={'datetime-local'}
                    value={inputsCrea?.dataOraOperazione || ''}
                    onChange={(name , value) => setInputsCrea(values => ({ ...values, [name]: value }))}
                    classi={' col-4 '}
                    errors={error}
                    max={format(new Date(), "yyyy-MM-dd'T'HH:mm")}
                />
                <div className="pt-5 mt-2">
                    <button className=" btn btn-primary m-3 mt-4" onClick={()=> onCloseInv(0)} >
                        Annulla
                    </button>
                    <button className=" btn btn-primary m-3 mt-4" onClick={()=> onCloseInv(1)}>
                        Salva
                    </button>
                </div>
                {/* <FormError field='prodottoId' errors={error} />
                <FormError field='qtAttualeRilevata' errors={error} classi=' ps-4' /> */}
            </div>

        </div>
    )

}